import * as React from 'react';
import { Text } from '@doordash/design-language';
import Button from '@doordash/component-button';
import { JoinByInviteStrings } from './JoinByInviteStrings';
import { useGetConsumerDetails } from '../../hooks/useGetConsumerDetails';
import track from '../../utils/track';
import { JoinV2PageEvents } from '../../constants/events/names';
var ChooseAccountView = function (_a) {
    var _b;
    var companyName = _a.companyName, joinTeamAccountsV2Loading = _a.joinTeamAccountsV2Loading, joinTeamAccountsV2Data = _a.joinTeamAccountsV2Data, joinByInvite = _a.joinByInvite, chooseToUseAnotherAccount = _a.chooseToUseAnotherAccount, pendingMemberId = _a.pendingMemberId;
    var _c = useGetConsumerDetails(), userData = _c.data, userDataLoading = _c.loading;
    var userEmail = userDataLoading ? '' : (_b = userData.consumer) === null || _b === void 0 ? void 0 : _b.email;
    var isLoadingStateForPrimaryButton = userDataLoading ||
        joinTeamAccountsV2Loading ||
        (joinTeamAccountsV2Data === null || joinTeamAccountsV2Data === void 0 ? void 0 : joinTeamAccountsV2Data.success); // display a loading indicator before fully redirecting to the Benefits page
    var onUseCurrentAccountClick = function () {
        track(JoinV2PageEvents.WORK_PORTAL_JOIN_PAGE_V2_USE_DEFAULT_ACCOUNT_CLICK, {
            pending_member_id: pendingMemberId,
        });
        joinByInvite();
    };
    var onUseAnotherAccountClick = function () {
        track(JoinV2PageEvents.WORK_PORTAL_JOIN_PAGE_V2_USE_ANOTHER_ACCOUNT_CLICK, {
            pending_member_id: pendingMemberId,
        });
        chooseToUseAnotherAccount();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(React.Fragment, null,
            React.createElement(Text, { styles: Text.Styles.PageTitle2, textAlign: Text.TextAlignments.Center }, JoinByInviteStrings.chooseAccountView.title(companyName)),
            React.createElement(Text, { styles: Text.Styles.Body1, textAlign: Text.TextAlignments.Center }, JoinByInviteStrings.chooseAccountView.body()),
            React.createElement(Button, { type: Button.Types.Primary, isDisabled: isLoadingStateForPrimaryButton, state: isLoadingStateForPrimaryButton
                    ? Button.States.Loading
                    : Button.States.Default, onClick: onUseCurrentAccountClick }, JoinByInviteStrings.chooseAccountView.currentAccountButton(userEmail)),
            React.createElement(Button, { type: Button.Types.Tertiary, isDisabled: isLoadingStateForPrimaryButton, onClick: onUseAnotherAccountClick }, JoinByInviteStrings.shared.anotherAccountButton()))));
};
export default ChooseAccountView;
